import { useState, useEffect, lazy, Suspense } from "react";

/*
import { html } from '@/utils/Format';
import { date } from '@/utils/Dates';
const Box = lazy(() => import('@mui/material/Box'));
const Card = lazy(() => import('@mui/material/Card'));
const CardContent = lazy(() => import('@mui/material/CardContent'));
const CardActionArea = lazy(() => import('@mui/material/CardActionArea'));
const Chip = lazy(() => import('@mui/material/Chip'));
const TicketModal = lazy(() => import('/src/modals/NotificationModal'));
*/

import { styleTabs } from '@/utils/Styles';
const Tabs = lazy(() => import('@mui/material/Tabs'));
const Tab = lazy(() => import('@mui/material/Tab'));
const ManageIcon = lazy(() => import('@mui/icons-material/ManageAccounts'));
const StatsIcon = lazy(() => import('@mui/icons-material/BarChart'));

const Table = lazy(() => import('/src/components/Table'));
const TicketsStats = lazy(() => import('/src/pages/Tickets/TicketsStats'));
const Ticket = lazy(() => import('/src/pages/Tickets/Ticket'));

import { getCurrentTab, getNewUrl } from '@/utils/Tabs';

import { checkViewItem, checkViewType } from '@/utils/Table';

export default function Tickets({ t, language, user, apiUrl, token, router, 
    getData, setData, deleteData, sendMessage,handleLogin, fullScreen, fullPage, setFullPage, openUrlModal
}) {

    const [ api, setApi ] = useState(null);

    // response from the api when getting data
    const [ response, setResponse ] = useState(null);

    // for the ticket details
    const [ itemDetails, setItemDetails ] = useState(null);

    const [ table ] = useState('tickets');

    // save table config
    const [ config, setConfig ] = useState(null);

    // set if table is editable
    const [ editable, setEditable ] = useState(true); 

    const [ viewPath, setViewPath ] = useState(checkViewType(router.pathname)); 

    // edition mode: modal true/false
    const [ modalDefault ] = useState(true);
    const [ modal, setModal ] = useState(true);

    const { sxTabs, sx, sxIcon } = styleTabs();
    const tabs = ['manage','stats'];
    const [ tab, setTab ] = useState(getCurrentTab(router,tabs));

    const handleTabChange = (event, newValue) => {
        
        setTab(newValue);
        const url = getNewUrl(router,table,tabs,newValue);
        router.navigate(url);
        //window.history.pushState({path:url},'',url);

        // if clicking tab, go out of item details if there
        setItemDetails(null);
    };

    // detect tab reclick
    const handleTabReClick = (clickedTabValue) => {
    
        // if clicking on same tab
        if(clickedTabValue === tab){
            // if clicking tab, go out of item details if there
            setItemDetails(null);
        }
    }

    const [loading, setLoading] = useState(false);
    const [columns, setColumns] = useState([]);
    const [tableRows, setTableRows] = useState([]);

    const resetData = () => {
        if(columns && Object.keys(columns).length > 0){
            setColumns(null);
        }

        if(tableRows && tableRows.length > 0){
            setTableRows(null);
        }
    };

    // if clicking on the menu
    useEffect(() => {
        
        if(router.pathname){
            
            // go back to main tab
            setTab(getCurrentTab(router,tabs));

            // if clicking on menu and in item details, go back to list
            const { viewType } = checkViewItem(router);
            if(!viewType){
                setItemDetails(null);
            }
        }

    }, [router.pathname]);

    // get data
    useEffect(() => {  

        // set null to get the new item if on item view
        setItemDetails(null);

        // check if view item details        
        const { viewType, viewItemId } = checkViewItem(router);
        setViewPath(viewType);

        // fullview does not have back button, so get only 1 row, not all
        var itemId = null;
        if(viewType === 'fullview'){
            itemId = viewItemId;
        }

        handleGet(router.pathname,table,setLoading,setColumns,setTableRows,setConfig,resetData,setResponse,setEditable,modalDefault,setModal,setItemDetails,itemId);

    }, []);

    // to retrieve the data
    const handleGet = (pathname,table,setLoading,setColumns,setTableRows,setConfig,resetData,setResponse,setEditable,modalDefault,setModal,setItemDetails = null,itemId = null) => {
        getData(pathname,table,setLoading,setColumns,setTableRows,setConfig,resetData,setResponse,setEditable,modalDefault,setModal,setItemDetails,itemId);
    }

    // refresh data    
    const handleRefresh = () => {        
        handleGet(router.pathname,table,setLoading,setColumns,setTableRows,setConfig,resetData,setResponse,setEditable,modalDefault,setModal);
    }

    // add/edit a row
    // if inline edition, we use setSavedEnabled
    // if modal edition, we use handleCloseItemModal
    const handleEdit = (action,api,node,data,setSavedEnabled = null,setAddDisabled=null,handleCloseItemModal = null) => {                
        setData(action,router.pathname,table,api,node,modal,data,columns,setTableRows,setSavedEnabled,setAddDisabled,handleCloseItemModal);
    }

    // delete a row
    const handleDelete = (selectedRows,api,handleCloseItemModal = null) => {
        deleteData(router.pathname,table,selectedRows,api,columns,setTableRows,handleCloseItemModal);
    }

    // to handle when clicking on the view button or double click the row
    const handleItemViewAction = (params) => {
        
        //const ticketId = params?.data?.id;
        //const ticket = params?.node;
        //const ticket = params;        

        if(params){

            const node = params?.node;

            // go to ticket details
            setItemDetails(node?.data);

            // change url to can copy the url and open directly to the ticket
            var url = '/'+table+'/view/'+params?.node?.data?.id;
            router.navigate(url);
            //window.history.pushState({path:url},'',url);
        }
        else{
            sendMessage(t('error.dataretrievingerror'),'error');
        }
    }

    // to go back to the tickets' list
    const [ rowsData, setRowsData ] = useState(null);
    const handleBack = () => {

        // if full view, go to tickets list but going to url to get again list of tickets
        if(viewPath === 'fullview'){
            const url = '/'+table;
            window.location.href = url;            
        }
        else{
            // set items to be modified on the table once loaded
            // on this case it is only an item
            setRowsData([itemDetails]);

            // update rows on the table

            // remove itemDetails to show table
            setItemDetails(null);
        }
    }

    return (
        <div className='tabs-container'>   
            {
                viewPath !== 'fullview' &&
                <Suspense>
                    <Tabs                     
                        id="tabs"                
                        sx={sxTabs}                
                        value={tab} 
                        onChange={handleTabChange}
                        variant="scrollable"                    
                    >
                        <Tab 
                            icon={<ManageIcon sx={sxIcon}/>} 
                            value="manage" 
                            label={t(table+'.tabs.manage')} 
                            sx={sx}
                            onClick={() => handleTabReClick('manage')}
                        />
                        <Tab 
                            icon={<StatsIcon sx={sxIcon}/>} 
                            value="stats" 
                            label={t(table+'.tabs.stats')} 
                            sx={sx}
                            onClick={() => handleTabReClick('stats')}
                        />                                        
                    </Tabs>
                </Suspense>
            }
            
            <div className='mt-8 h-full'>
            {
                tab === 'manage' ?
                    itemDetails ?
                        <Suspense>
                            <Ticket                                
                                t={t}
                                language={language}
                                user={user}
                                apiUrl={apiUrl}
                                token={token}
                                table={table}                                
                                ticket={itemDetails}                                
                                columns={columns}
                                response={response}
                                handleBack={handleBack}                                
                                router={router}                                
                                handleLogin={handleLogin}
                                sendMessage={sendMessage}
                                fullScreen={fullScreen}
                                viewPath={viewPath}
                            />
                        </Suspense>
                    :
                        (columns && Object.keys(columns).length > 0) &&
                        (tableRows !== null) &&
                        <Suspense>
                            <Table  
                                api={api}
                                setApi={setApi}  
                                apiUrl={apiUrl} 
                                token={token}
                                handleLogin={handleLogin}
                                loading={loading}
                                t={t}
                                language={language}
                                user={user}
                                router={router}
                                table={table}
                                config={config}
                                modal={modal}
                                rows={tableRows}                                
                                rowsData={rowsData}
                                columns={columns}
                                response={response}                                
                                handleEdit={handleEdit}
                                handleDelete={handleDelete}
                                handleRefresh={handleRefresh}
                                editable={editable}
                                sendMessage={sendMessage}   
                                handleItemViewAction={handleItemViewAction}
                                enableAdd={true} // in case we are customer, edition is disabled, so force enable add   
                                fullScreen={fullScreen}  
                                fullPage={fullPage} 
                                setFullPage={setFullPage}  
                                openUrlModal={openUrlModal}                        
                            />
                        </Suspense>
                :
                    <div className='mt-12'>
                        <Suspense>
                            <TicketsStats 
                                t={t}                                
                                tickets={tableRows}
                                columns={columns}
                            />
                        </Suspense>
                    </div>
            }
            </div>
        </div>
    );
}